import React from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useLoading } from "./LoadingProvider";

const styles = {
  container: {
    position: "sticky",
    bottom: "10px",
    width: "100%",
    left: 0,
    zIndex: 99,
    backgroundColor: "white",
  },
};

export default function FormActions() {
  const { submitForm, isSubmitting } = useFormikContext();
  const { loading } = useLoading();
  const isSaveDisabled = loading || isSubmitting;

  const handleSave = async () => {
    try {
      await submitForm();
    } catch (error) {
      console.error("Error saving:", error);
    }
  };

  return (
    <Box sx={styles.container}>
      <Button
        fullWidth
        type="button"
        variant="contained"
        color="primary"
        onClick={handleSave}
        disabled={isSaveDisabled}
        startIcon={isSubmitting && <CircularProgress size={22} />}
      >
        Save
      </Button>
    </Box>
  );
}
